import React from "react";
import { PieChart, Pie, Cell } from "recharts";
import "./RiskByBusinessUnit.css";

const data = [
  { name: "Customer Service", value: 38 },
  { name: "Marketing", value: 62 },
];

const COLORS = ["#445463", "#0b2233"];

const RiskByBusinessUnit = () => {
  return (
    <div className="risk-card-rbu">
      <h3 className="risk-title-rbu">Risk by business unit</h3>
      <p className="risk-subtitle-rbu">Last update at 3 Nov</p>

      <div className="risk-content-rbu">
        <div className="risk-chart-wrapper-rbu">
          <PieChart width={220} height={220}>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={70}
              outerRadius={100}
              startAngle={90}
              endAngle={-270}
              dataKey="value"
              stroke="none"
            >
              {data.map((entry, index) => (
                <Cell key={index} fill={COLORS[index]} />
              ))}
            </Pie>
          </PieChart>

          <div className="risk-center-text-rbu">62%</div>
        </div>

        <div className="risk-legend-rbu">
          <div className="legend-item-rbu">
            <span className="legend-color-rbu cs"></span>
            Customer Service
          </div>
          <div className="legend-item-rbu">
            <span className="legend-color-rbu mk"></span>
            Marketing
          </div>
        </div>
      </div>
    </div>
  );
};

export default RiskByBusinessUnit;
